import React from "react";

class Question extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      descClass: false
    };
  }

  toggle() {
    this.setState({
      descClass: !this.state.descClass
    });
    console.log(this.state.descClass);
  }
  render() {
    return (
      <div className="list">
        <h6 className="question" onClick={this.toggle.bind(this)}>
          <i className="ion ion-md-add-circle-outline"></i>
          {this.props.question}
        </h6>
        <div
          className={
            this.state.descClass ? "desc animated fadeIn" : "desc d-none"
          }
          dangerouslySetInnerHTML={{ __html: this.props.desc }}
        ></div>
      </div>
    );
  }
}

class Faq extends React.Component {
  render() {
    return (
      <section
        id="faq"
        style={{ backgroundImage: "url(images/section-background-03.png)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-6 offset-md-3">
              <div className="section-title">
                <h2>Frequently Asked Questions</h2>
              </div>
              <h3>About the Competition</h3>
              <Question
                question="Given the current situation with the Novel Coronavirus, will  I’m the Best Coder! Challenge Campus Edition 2020 be cancelled?"
                desc="No, the event will not be cancelled. Instead, it will be postponed until further notice. Registration will remain open for all interested individuals. Do sign up now before our slots get full!"
              />
              <Question
                question="Where can I find event updates with regards to the Novel Coronavirus?"
                desc="I’m the Best Coder! Challenge Campus Edition 2020 website will be updated regularly. Registered teams will receive additional email notifications should there be any event updates. If you have any queries, do reach out to us at techsg@shopee.com!"
              />
              <Question
                question="Am I required to code in Python?"
                desc="No, you can use any other programming languages. "
              />
              <Question
                question="I have no/little knowledge about coding. Can I still participate? "
                desc="Yes."
              />
              <Question
                question="Is it necessary for the whole team to stay throughout the competition? "
                desc="Yes, the entire team has to be physically present throughout the competition. For pairs, your team will be automatically disqualified if either members leave. 

                For teams of 3 or 4, it will be on a case-by-case basis. 
                "
              />
              <Question
                question="What do I have to bring to the competition? "
                desc="Please bring along your own set of laptop, charger and adaptor as no equipment will be provided. Each team member is restricted to one set of laptop, charger and adaptor."
              />
              <Question
                question="What is the difference between I’m the Best Coder! Challenge 2019 and this upcoming Campus Edition?"
                desc="The Campus Edition is only open to undergraduates of all universities in Singapore. While it follows the same format, the cases will be different."
              />
              <Question
                question="Can I access the Internet during the competition?"
                desc="Yes."
              />
              <Question
                question="Where is the competition held?"
                desc="The competition will be held at the National University of Singapore, University Sports Centre (2 Sports Drive, 117561)."
              />
              <Question
                question="When and what time is the competition?"
                desc="Competition date and time will be revealed at a later date."
              />
              <h3>Eligibility</h3>
              <Question
                question="What is the age limit?"
                desc="While there is no age limit, only undergraduate students are allowed to participate in this challenge."
              />
              <Question
                question="I will be an incoming freshman in August 2020. Can I still register?"
                desc="You may register as per normal if you already have your matriculation number. If you have not yet obtained a valid matriculation number, please write in to us at techsg@shopee.com with your submission ID and an official university acceptance letter."
              />
              {/* <Question
                question="I am joining Shopee as an intern/ full-time employee in June. Can I participate?"
                desc="If you have a valid matriculation number from a university in Singapore as of 13 March 2020, you may participate."
              /> */}
              <Question
                question="I am an exchange student at a local university. Can I participate?"
                desc="Yes, as long as you have a valid matriculation number from a university in Singapore, you can participate."
              />
              <Question
                question="I’m a postgraduate student from a local university. Can I participate?"
                desc="No, this competition is only open to undergraduates."
              />
              <Question
                question="My team consists of members from different faculties and/or universities. Can we still form a team? "
                desc="Yes, so long as all members are undergraduates studying at a local university. "
              />
              <h3>Registration</h3>
              <Question
                question="Can I sign up as an individual? "
                desc="We will not accept any individual sign-ups."
              />
              <Question
                question="Will every team member have to submit the registration form once? "
                desc="No, registration is done by team. You only need to submit one form as a team as each form will require all members to fill in their details."
              />
              <Question
                question="How do I know if my registration for Best Coder Campus 2020 is successful?"
                desc="A confirmation email will be sent to you after you submit the form. If you did not receive it, please write in to us at techsg@shopee.com to check your registration status. "
              />
              <Question
                question="Does my registration via this form guarantee my team a seat during the actual competition?"
                desc="No, it does not. Your team will receive a second confirmation email to indicate if your team has been successfully registered."
              />
              <Question
                question="When does registration close?"
                desc="Registration will remain open until the new event date has been confirmed, or until further notice."
              />
              <Question
                question="When filling in the registration form, I keyed in my details incorrectly. How do I make changes to it after the submission?"
                desc="Please write in to techsg@shopee.com with your Submission ID and Team Name. We will remove your previous application and you can resubmit the application form with the correct details."
              />
              {/* <Question
                question="My team would like to remove a member. How do we do so? "
                desc="Please write in to techsg@shopee.com with the following details:
                <br/>
                1. Your name
                <br/>
                2. Team name
                <br/>
                3. Member’s name (to be removed) 
                "
              /> */}
              <Question
                question="I would like to add/ change/ remove a member. How do we do so?"
                desc="Please write in to techsg@shopee.com with your Submission ID and Team Name. We will remove your previous application and you can resubmit the application form."
              />
              <Question
                question="On the event day, must I register my attendance with my team or can I do so individually?"
                desc="You must register your attendance with your team. All team members must be present before you can enter the hall."
              />

              {/* <h3>Training Workshops</h3>
              <Question
                question="Can I participate in more than one training workshop?"
                desc="As slots are limited, priority will be given to participants from the respective categories. Do check with us and we will open the seat for you if there are vacancies."
              />
              <Question
                question="When can I receive my deposit refund for the training workshop(s) that I have attended?"
                desc="
                <p>Deposits made during training workshops will be refunded by our training partners after participants completed I’m the Best Coder! Challenge 2019 successfully as a team. Deposits will be fully refunded to participants by 25 October 2019.</p>
                <p>Deposits will not be refunded to training workshop attendees who do not attend I’m the Best Coder! Challenge 2019.</p>
                "
              />
              <Question
                question="How can I receive the deposit refund for the training workshop(s) that I have attended? "
                desc="Deposit via Cash, PayLah or PayNow during training workshops
                <ul>
                  <li>Refunds will be via PayLah or PayNow.</li>
                  <li>Kindly fill up this <a href='https://docs.google.com/forms/d/e/1FAIpQLSeXegZm23SNjNCs6Q_11vVu5oGkzy45fc20OF7F8Qhfo_g0hA/viewform'>form</a> if you have made a Cash deposit during the training workshop, do not have any PayLah or PayNow and have not filled up the form before.</li>
                </ul>
                Deposit via Eventbrite prior to training workshops
                <ul>
                  <li>Refunds will be via PayPal or to your credit card, depending on the payment method that you have opt for on Eventbrite.</li>
                </ul>
                "
              />
              <Question
                question="I have attended 2 training workshops and made 2 deposits, how will I be refunded?"
                desc="You will be refunded via 2 separate transactions as our training workshops are conducted by different training partners."
              />
              <Question
                question="If my group member has attended the workshop but then is unable to attend the Competition, will the deposit be returned back to the other team members who will still be attending the Competition?"
                desc="The group member that is unable to attend the I'm the Best Coder! Challenge 2019 will not be able to get the deposit back. However, the rest of the team members that have already paid a deposit and will attend the I'm the Best Coder! Challenge 2019 will receive their deposits back after successfully completing the Challenge."
              />
              <Question
                question="One of my team members has withdrawn but is registered under the team name already. If that team member does not show up on the Competition day, will the other team members’ deposits be affected? "
                desc="No, it will not affect the deposits of the team as deposits will be refunded individually."
              />
              <Question
                question="I have someone to replace me for the training workshop. Will I get the deposit back if I completed I'm the Best Coder! Challenge 2019 successfully with my team?"
                desc="<p>The <strong>replacement</strong> for the training workshop <strong>will not</strong> get back his/her deposit even though he/she has made the deposit on your behalf for the training workshop.</p>
                <p>Since the training workshop is registered under your name, deposit will be refunded directly back to you instead. Therefore, deposit will be refunded to you if you have completed I’m the Best Coder! Challenge 2019 successfully with your team.</p>
                "
              /> */}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Faq;
